
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ReceiptDetailsGrid extends Serenity.EntityGrid<ReceiptDetailsRow, any> {
        protected getColumnsKey() { return 'ECommerce.ReceiptDetails'; }
        protected getDialogType() { return ReceiptDetailsDialog; }
        protected getIdProperty() { return ReceiptDetailsRow.idProperty; }
        protected getInsertPermission() { return ReceiptDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return ReceiptDetailsRow.localTextPrefix; }
        protected getService() { return ReceiptDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}